(function($) {
    $.widget('ca.caGenderToggle', {
        _create : function() {
            $('.gender-toggle-button button').on('click', function(e) {
                e.preventDefault();
				e.stopPropagation();
                var val = $(this).data('value');
                $(this).siblings('input[type=hidden]').val( val );
                $(this).siblings('button').addClass('btn-alt');
                $(this).removeClass('btn-alt');
            });
            var val = $(this.element).attr('value');
            if (val) {
                var $el = $(this.element).parent().find('*[data-value="' + val + '"]');
                $('.gender-toggle-button button').addClass('btn-alt');
                $($el).removeClass('btn-alt');
            }
        }
    });
})(jQuery);
